<template>
  <van-popup :show="show" @update:show="$emit('update:show', $event)" :close-on-click-overlay="false"
    class="security-dialog" round>
    <div class="security-content">
      <!-- 关闭按钮 -->
      <div class="header-container">
        <div class="spacer"></div>
        <div class="close-button" @click="handleClose">
          <img :src="getAssetsFile('activity/closepass.png')" alt="close" class="close-icon">
        </div>
      </div>

      <!-- 图标区域 -->
      <div class="icon-container">
        <div class="icon-circle">
          <img :src="getAssetsFile('activity/jiesuo.png')" alt="lock" class="lock-icon">
        </div>
        <!-- 消息文本 -->
        <div class="message-text">
          <div> {{ t('securityPasswordDialog.message') }}</div>
          <div class="buttonContainer">
            <div class="primaryButton" @click="handleSetNow">
              {{ t('securityPasswordDialog.setNow') }}
            </div>
            <div class="secondaryButton" @click="handleCancel">
              {{ t('securityPasswordDialog.cancel') }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'

const { t } = useI18n()

interface Props {
  show: boolean
  fromPage?: string
}

interface Emits {
  (e: 'update:show', value: boolean): void
  (e: 'setNow', fromPage: string): void
  (e: 'cancel'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const handleClose = () => {
  emit('update:show', false)
}

const handleSetNow = () => {
  emit('setNow', props.fromPage || 'security')
}

const handleCancel = () => {
  emit('cancel')
}
</script>

<style scoped>
.security-dialog {
  width: 100%;
  background: #004D37;
  border-radius: 16px;
}

.security-content {
  padding: 20px;
  text-align: center;
  height: 240px;
}

.header-container {
  display: flex;
  justify-content: space-between;
}

.spacer {
  width: 60%;
}

.close-button {
  cursor: pointer;
}

.close-icon {
  width: 11px;
  height: 11px;
}

.icon-container {
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.icon-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lock-icon {
  width: 100%;
  height: 100%;
}

.message-text {
  color: #ffffff;
  font-size: 13px;
  margin-top: 20px;
}

.buttonContainer {
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: center;
}

.primaryButton {
  width: 120px;
  padding: 0 24px;
  height: 40px;
  line-height: 40px;
  border-radius: 9px;
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(0deg, #1D9855 0%, #15D66F 100%);
  color: white;
}

.secondaryButton {
  width: 120px;
  padding: 0 24px;
  border-radius: 9px;
  height: 40px;
  line-height: 40px;
  font-size: 11px;
  font-weight: bold;
  background: transparent;
  color: white;
  text-align: center;
  border: 1px solid #008965;
  margin-left: 10px;
}
</style>
